/* ============================================================================
   ADMIN → FORMULAS → tab EXTRAS (PROTOTAIP DESIGN · 27 Okt 2026)
   ============================================================================
   Bahagian khas yang hari ini hanya muncul untuk SATU module dalam popup Module Settings:
   • GOYANG  — Hook fragments · Background fragments · System templates (preset_fragments/goyang,
               system_templates/goyang).
   • SMART   — ChatGPT system templates (system/chatgptTemplates).
   • FLOWNITY — Scrape agent (modules/flownity.scrapeConfig.{chatgpt|gemini}).
   Rupa SAHAJA (senarai contoh). ⚠️ Hari ini bahagian ini SIMPAN SENDIRI serta-merta (bukan melalui
   "Simpan Semua") — keputusan cara simpan dibuat bila disambung.
   ========================================================================== */
import { useState } from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { Btn, Badge, Segmented } from '../design/ui';
import { Kotak, Medan } from './FormulaAdminUi';
import { EXTRAS_CONTOH } from '../utils/formulaAdminContoh';

function SenaraiFragment({ tajuk, data, onNota }) {
    return (
        <Kotak tajuk={tajuk} kanan={<Btn variant="ghost" size="sm" icon={<Plus size={14} />} onClick={onNota}>Add</Btn>}>
            {data.map((x, i) => (
                <div key={x.nama} className="fma-baris" style={i === 0 ? { borderTop: 0 } : undefined}>
                    <span style={{ minWidth: 0 }}>
                        <span className="fma-block__nama">{x.nama} {x.sorok && <Badge>Hidden</Badge>}</span>
                        <span className="fma-block__nota">{x.pratonton} · {x.contoh} examples</span>
                    </span>
                    <Btn variant="quiet" size="sm" icon={<Pencil size={13} />} onClick={onNota}>Edit</Btn>
                </div>
            ))}
        </Kotak>
    );
}

export default function FormulaAdminExtras({ jenis, onNota }) {
    const nota = () => onNota('Design prototype — nothing is saved or run yet.');
    const [platform, setPlatform] = useState('chatgpt');

    if (jenis === 'goyang') {
        const g = EXTRAS_CONTOH.goyang;
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 860 }}>
                <SenaraiFragment tajuk="Hook fragments" data={g.hooks} onNota={nota} />
                <SenaraiFragment tajuk="Background fragments" data={g.bg} onNota={nota} />
                <Kotak tajuk="System templates" kanan={<Btn variant="ghost" size="sm" icon={<Plus size={14} />} onClick={nota}>Add</Btn>}>
                    {g.template.map((t, i) => (
                        <div key={t.nama} className="fma-baris" style={i === 0 ? { borderTop: 0 } : undefined}>
                            <span style={{ minWidth: 0 }}>
                                <span className="fma-block__nama">{t.nama} {t.bgSendiri && <Badge>Custom background</Badge>}</span>
                                <span className="fma-block__nota" style={{ whiteSpace: 'normal' }}>
                                    {t.set.map((s, n) => `Set ${n + 1}: ${s}`).join(' · ')} · Hand: {t.tangan}
                                </span>
                            </span>
                            <Btn variant="quiet" size="sm" icon={<Pencil size={13} />} onClick={nota}>Edit</Btn>
                        </div>
                    ))}
                    <p className="fma-nota" style={{ margin: '8px 0 0' }}>Each template: name · custom background image · hand (Auto / Female / Male) · Set 1–3 hook + background.</p>
                </Kotak>
            </div>
        );
    }

    if (jenis === 'smart') {
        return (
            <Kotak tajuk="ChatGPT system templates" kanan={<Btn variant="ghost" size="sm" icon={<Plus size={14} />} onClick={nota}>New template</Btn>} style={{ maxWidth: 860 }}>
                {EXTRAS_CONTOH.smart.map((t, i) => (
                    <div key={t.nama} className="fma-baris" style={i === 0 ? { borderTop: 0 } : undefined}>
                        <span style={{ minWidth: 0 }}>
                            <span className="fma-block__nama">{t.nama}</span>
                            <span className="fma-block__nota">{t.url} · {t.scene} scene{t.scene > 1 ? 's' : ''}{t.mapping ? ' · mapping set' : ''}</span>
                        </span>
                        <span style={{ display: 'flex', gap: 4 }}>
                            <Btn variant="quiet" size="sm" icon={<Pencil size={13} />} onClick={nota}>Edit</Btn>
                            <Btn variant="quiet" size="sm" icon={<Trash2 size={13} />} aria-label={`Delete ${t.nama}`} onClick={nota} />
                        </span>
                    </div>
                ))}
                <p className="fma-nota" style={{ margin: '8px 0 0' }}>Each template: name · description · GPT URL · 1 or 2 scenes · prompt template ({'{productName}'}, {'{productLink}'}, {'{imageUrl}'}) · field mapping.</p>
            </Kotak>
        );
    }

    if (jenis === 'flownity') {
        const c = EXTRAS_CONTOH.flownity[platform];
        return (
            <Kotak tajuk="Scrape agent (admin)" kanan={<Btn size="sm" onClick={nota}>Save {platform === 'chatgpt' ? 'ChatGPT' : 'Gemini'}</Btn>} style={{ maxWidth: 760 }}>
                <div className="fma-borang" style={{ maxWidth: 'none' }}>
                    <Segmented value={platform} onChange={setPlatform}
                        options={[{ value: 'chatgpt', label: `ChatGPT${EXTRAS_CONTOH.flownity.chatgpt.url ? ' ✓' : ''}` }, { value: 'gemini', label: `Gemini (Gems)${EXTRAS_CONTOH.flownity.gemini.url ? ' ✓' : ''}` }]} />
                    <Medan id="fma-fl-url" label={platform === 'chatgpt' ? 'Custom GPT URL' : 'Gem URL'}>
                        <input id="fma-fl-url" className="s-input" defaultValue={c.url} key={`${platform}-url`} placeholder="https://…" />
                    </Medan>
                    <Medan id="fma-fl-nama" label="Display name">
                        <input id="fma-fl-nama" className="s-input" defaultValue={c.nama} key={`${platform}-nama`} maxLength={40} />
                    </Medan>
                    <Medan id="fma-fl-ayat" label="Message sent to the GPT / Gem">
                        <textarea id="fma-fl-ayat" className="fma-teks" defaultValue={c.ayat} key={`${platform}-ayat`} style={{ minHeight: 70 }} />
                    </Medan>
                    <Medan label="Field mapping" nota="Scene 1–5 video prompt / script + caption, read from the agent's answer.">
                        <Btn variant="ghost" size="sm" onClick={nota}>{c.mapping ? 'Edit mapping' : 'Set mapping'}</Btn>
                    </Medan>
                </div>
            </Kotak>
        );
    }
    return null;
}
